<template>
  <div id="foot">
    <div class="block-left">
      <a href="http://paprica.ag/"><img class="paprica" :src="Paprica" alt="paprica"></a>
    </div>
    <div class="block-middle">
      <div class="caption">
        <span>Estratégico</span>
        <span>Tático</span>
        <span>Operacional</span>
        <div class="questionMark" @click="openModal">
          <img :src="Question" alt="questão">
        </div>
      </div>
    </div>
    <div class="block-right">
       <img :src="LogoFTD" height="33" alt="logo ftd">
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';
  import LogoMarista from 'Assets/images/logo-grupo.png';
  import LogoDHO from 'Assets/images/logo-dho.png';
  import LogoFTD from 'Assets/images/logo-ftd.png';
  import Question from 'Assets/images/question.svg';
  import Paprica from 'Assets/images/paprica.svg';

  export default {
    props: {},
    data() {
      return {
        LogoDHO,
        LogoMarista,
        LogoFTD,
        Paprica,
        Question,
      };
    },

    // Lifecyle
    created() {},
    // Methods
    computed: {},
    methods: {
      openModal() {
        EventSystem.$emit('help-open');
      }
    },
  };

</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/foot.vue